import { z } from "zod";
export const ZHelloPayload = z.object({
    message: z.string().min(1),
    count: z.number().int().nonnegative().optional(),
});
